import { useContext } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import LoginForm from "../pages/LoginForm/LoginForm";
import Signin from "../pages/Signin";
import ForgotPass from "../pages/ForgotPass";

const NotAuthenticated = () => {
  const { screen } = useContext(RegistrationContext);

  if (screen === "login") {
    return <LoginForm />;
  }
  if (screen === "forgotpass") {
    return <ForgotPass />;
  }
  if (screen === "signin") {
    return <Signin />;
  }
};

export default NotAuthenticated;
